module.exports = __webpack_public_path__ + "img/back.01d7171d.png";